export const FETCH_ALLERGY_REQUEST = "FETCH_ALLERGY_REQUEST";
export const FETCH_ALLERGY_SUCCESS = "FETCH_ALLERGY_SUCCESS";
export const FETCH_ALLERGY_FALIURE = "FETCH_ALLERGY_FALIURE";

export const POST_ALLERGY_REQUEST = "POST_ALLERGY_REQUEST";
export const POST_ALLERGY_SUCCESS = "POST_ALLERGY_SUCCESS";
export const POST_ALLERGY_FALIURE = "POST_ALLERGY_FALIURE";

export const GET_ALLERGY_REACTION_REQUEST = "GET_ALLERGY_REACTION_REQUEST";
export const GET_ALLERGY_REACTION_SUCCESS = "POST_ALLERGY_REACTION_SUCCESS";
export const GET_ALLERGY_REACTION_FALIURE = "POST_ALLERGY_REACTION_FALIURE";

export const GET_ALLERGY_SEVERTIES_REQUEST = "POST_ALLERGY_SEVERTIES_REQUEST";
export const GET_ALLERGY_SEVERTIES_SUCCESS = "POST_ALLERGY_SEVERTIES_SUCCESS";
export const GET_ALLERGY_SEVERTIES_FALIURE = "POST_ALLERGY_SEVERTIES_FALIURE";

export const DELETE_ALLERGY_REQUEST = "DELETE_ALLERGY_REQUEST";
export const DELETE_ALLERGY_SUCCESS = "DELETE_ALLERGY_SUCCESS";
export const DELETE_ALLERGY_FALIURE = "DELETE_ALLERGY_FALIURE";

export const UPDATE_ALLERGY_REQUEST = "UPDATE_ALLERGY_REQUEST";
export const UPDATE_ALLERGY_SUCCESS = "UPDATE_ALLERGY_SUCCESS";
export const UPDATE_ALLERGY_FALIURE = "UPDATE_ALLERGY_FALIURE";